import React, { PureComponent } from 'react';
import styled from 'styled-components';
import { AppointmentProvider } from '../../contexts';
import AppointmentContainer from '../../components/Appointment/AppointmentContainer';

const Container = styled.div`
  display: block;
  background-color: #ffffff;
`;
const Title = styled.span`
  height: 88px;
  font-weight: bold;
  font-size: 24px;
  display: flex;
  align-items: center;
  letter-spacing: 0.25px;
  color: #06a3b4;
  padding: 0 24px;
`;

export default class Appointment extends PureComponent {
  render() {
    return (
      <Container>
        <Title>นัดหมายของฉัน</Title>
        <AppointmentProvider>
          <AppointmentContainer />
        </AppointmentProvider>
      </Container>
    );
  }
}
